/** Traced from `src/assets/symbols/fåtölj  2-01.svg` (MANUAL/Lounge-chair-2). */
export const LOUNGE_CHAIR_2_SVG_BOUNDS = {
  minX: 21.15,
  maxX: 123.93,
  minY: 23.16,
  maxY: 126.09,
} as const;

export const LOUNGE_CHAIR_2_SEAT_SVG_OUTLINE: [number, number][] = [
  [53.64, 64.29],
  [56.79, 63.06],
  [61.05, 61.74],
  [65.61, 60.72],
  [70.23, 60.3],
  [75.84, 60.3],
  [81.3, 61.11],
  [85.65, 62.22],
  [88.86, 63.27],
  [90.75, 64.08],
  [91.35, 64.41],
  [92.43, 59.88],
  [93.21, 56.49],
  [93.96, 51.72],
  [94.38, 46.23],
  [94.74, 41.04],
  [94.98, 39.69],
  [95.49, 37.62],
  [96.33, 36.09],
  [97.65, 34.77],
  [99.36, 33.78],
  [101.22, 33.21],
  [103.35, 32.79],
  [106.585, 43.525],
  [109.82, 54.26],
  [113.055, 64.995],
  [116.29, 75.73],
  [119.525, 86.465],
  [122.76, 97.2],
  [121.98, 102.12],
  [120.66, 107.61],
  [119.52, 111.39],
  [118.38, 113.91],
  [117.18, 115.59],
  [115.38, 117.54],
  [113.1, 119.43],
  [110.07, 121.29],
  [107.88, 122.46],
  [105.81, 123.3],
  [103.14, 124.14],
  [100.53, 124.71],
  [97.47, 125.19],
  [92.25, 125.7],
  [89.25, 125.85],
  [81.93, 126.09],
  [53.46, 125.76],
  [51.69, 125.61],
  [48.78, 125.31],
  [45.3, 124.83],
  [41.37, 124.02],
  [38.1, 122.91],
  [35.64, 121.71],
  [32.52, 119.82],
  [29.67, 117.63],
  [27.09, 114.87],
  [25.38, 111.27],
  [23.94, 106.14],
  [22.83, 100.8],
  [22.11, 96.12],
  [21.66, 90.24],
  [21.33, 83.46],
  [21.15, 72.6],
  [21.45, 65.43],
  [22.05, 61.23],
  [23.73, 55.08],
  [26.04, 49.74],
  [27.6, 47.04],
  [30.36, 43.08],
  [33.81, 39.27],
  [36.87, 36.42],
  [41.01, 33.21],
  [41.7, 32.82],
  [42.48, 32.97],
  [43.68, 33.21],
  [44.94, 33.51],
  [45.87, 33.9],
  [46.95, 34.47],
  [47.76, 35.16],
  [48.57, 36.03],
  [49.44, 37.59],
  [49.77, 38.7],
  [50.22, 40.41],
  [50.43, 42.54],
  [50.52, 43.92],
  [50.61, 47.55],
  [50.97, 51.75],
  [52.44, 59.04],
  [53.64, 64.29],
];

export const LOUNGE_CHAIR_2_LEFT_ARM_SVG_OUTLINE: [number, number][] = [
  [41.7, 32.82],
  [43.68, 33.21],
  [44.94, 33.51],
  [45.87, 33.9],
  [46.95, 34.47],
  [47.76, 35.16],
  [48.57, 36.03],
  [49.44, 37.59],
  [49.77, 38.7],
  [50.22, 40.41],
  [50.43, 42.54],
  [50.52, 43.92],
  [50.61, 47.55],
  [50.97, 51.75],
  [52.44, 59.04],
  [53.64, 64.29],
  [47.16, 68.16],
  [41.79, 72.6],
  [35.73, 79.29],
  [32.13, 83.79],
  [29.4, 88.65],
  [28.41, 90.84],
  [27.63, 92.13],
  [26.7, 93.27],
  [25.86, 93.93],
  [24.69, 94.44],
  [23.7, 94.62],
  [21.99, 94.62],
  [22.11, 96.12],
  [21.66, 90.24],
  [21.33, 83.46],
  [21.15, 72.6],
  [21.45, 65.43],
  [22.05, 61.23],
  [23.73, 55.08],
  [26.04, 49.74],
  [27.6, 47.04],
  [30.36, 43.08],
  [33.81, 39.27],
  [36.87, 36.42],
  [41.01, 33.21],
  [41.7, 32.82],
];

export const LOUNGE_CHAIR_2_CENTER_BACK_SVG_OUTLINE: [number, number][] = [
  [53.64, 64.29],
  [56.79, 63.06],
  [61.05, 61.74],
  [65.61, 60.72],
  [70.23, 60.3],
  [75.84, 60.3],
  [81.3, 61.11],
  [85.65, 62.22],
  [88.86, 63.27],
  [90.75, 64.08],
  [91.35, 64.41],
  [93.21, 56.49],
  [93.96, 51.72],
  [94.44, 45.48],
  [94.74, 41.04],
  [94.98, 39.69],
  [95.49, 37.62],
  [96.33, 36.09],
  [97.65, 34.77],
  [99.36, 33.78],
  [101.22, 33.21],
  [103.35, 32.79],
  [101.13, 31.32],
  [99.03, 30.15],
  [98.67, 29.94],
  [95.37, 28.29],
  [90, 26.16],
  [85.02, 24.63],
  [79.56, 23.52],
  [77.82, 23.31],
  [75.45, 23.16],
  [69.42, 23.16],
  [68.04, 23.22],
  [65.55, 23.52],
  [60.33, 24.54],
  [54.24, 26.37],
  [50.37, 27.99],
  [46.53, 29.88],
  [41.7, 32.82],
  [42.48, 32.97],
  [43.68, 33.21],
  [44.94, 33.51],
  [45.87, 33.9],
  [46.95, 34.47],
  [47.76, 35.16],
  [48.57, 36.03],
  [49.44, 37.59],
  [49.77, 38.7],
  [50.22, 40.41],
  [50.43, 42.54],
  [50.52, 43.92],
  [50.61, 47.55],
  [50.97, 51.75],
  [52.44, 59.04],
  [53.64, 64.29],
  [47.16, 68.16],
  [41.79, 72.6],
  [35.73, 79.29],
  [32.13, 83.79],
  [29.4, 88.65],
  [28.41, 90.84],
  [27.63, 92.13],
  [26.7, 93.27],
  [25.86, 93.93],
  [24.69, 94.44],
  [23.7, 94.62],
  [21.99, 94.62],
  [23.7, 94.62],
  [24.69, 94.44],
  [25.86, 93.93],
  [26.7, 93.27],
  [27.63, 92.13],
  [28.41, 90.84],
  [29.4, 88.65],
  [32.13, 83.79],
  [35.73, 79.29],
  [41.79, 72.6],
  [47.16, 68.16],
  [53.64, 64.29],
];

export const LOUNGE_CHAIR_2_RIGHT_ARM_SVG_OUTLINE: [number, number][] = [
  [91.35, 64.41],
  [92.43, 59.88],
  [93.21, 56.49],
  [93.96, 51.72],
  [94.38, 46.23],
  [94.74, 41.04],
  [94.98, 39.69],
  [95.49, 37.62],
  [96.33, 36.09],
  [97.65, 34.77],
  [99.36, 33.78],
  [101.22, 33.21],
  [103.35, 32.79],
  [103.41, 32.79],
  [103.47, 32.85],
  [106.59, 35.28],
  [108.93, 37.08],
  [112.86, 40.95],
  [115.2, 43.74],
  [118.08, 48],
  [121.47, 55.47],
  [123.09, 61.65],
  [123.63, 65.34],
  [123.93, 74.55],
  [123.51, 87.39],
  [123.06, 94.56],
  [122.85, 94.62],
  [122.25, 94.62],
  [121.2, 94.62],
  [120.75, 94.53],
  [120.24, 94.41],
  [119.64, 94.2],
  [118.83, 93.78],
  [118.35, 93.39],
  [117.69, 92.61],
  [116.67, 91.05],
  [115.56, 88.62],
  [114.33, 86.22],
  [113.43, 84.72],
  [112.47, 83.52],
  [110.52, 80.91],
  [107.4, 77.25],
  [104.25, 73.74],
  [99.03, 69.06],
  [93.27, 65.31],
  [91.35, 64.38],
];
